import React from "react"
import ReactDOM from "react-dom"
import { Canvas } from "react-three-fiber"
import { ACESFilmicToneMapping, sRGBEncoding } from "three"
import Scene from "./Scene"
import "./styles.css"

function App() {
  return (
    <Canvas
      pixelRatio={window.devicePixelRatio}
      gl={{ alpha: false, antialias: false }}
      camera={{ fov: 40, position: [0, 0, 3] }}
      onCreated={({ gl }) => {
        gl.setClearColor(0x000000, 0)
        //gl.toneMapping = ACESFilmicToneMapping
        // gl.outputEncoding = sRGBEncoding
      }}>
      <Scene />
    </Canvas>
  )
}

ReactDOM.render(<App />, document.getElementById("root"))
